import {
  SET_USED_RUTS,
} from './types';

const initialState = {
  usedRuts: {},
  regex: /[^A-Za-zäÄëËïÏöÖüÜáéíóúáéíóúÁÉÍÓÚÂÊÎÔÛâêîôûàèìòùÀÈÌÒÙ0-9.,@Ññ ]/i,
};

export default function (state = initialState, action) {
  const { payload } = action;
  switch (action.type) {
    case SET_USED_RUTS:
      return { ...state, usedRuts: payload };
    default:
      return state;
  }
};
